// extracted by mini-css-extract-plugin
export default {"SkeletonSearchForm":"SkeletonSearchForm_SkeletonSearchForm__OUkdx","skeleton-search-control-item":"SkeletonSearchForm_skeleton-search-control-item__bQrAR"};